import { jsx as _jsx } from "react/jsx-runtime";
import { appTheme } from "../styles/appTheme";
export default function AppSectionCard({ children, style = {}, }) {
    return (_jsx("div", { style: {
            borderRadius: "12px",
            border: "none",
            background: appTheme.colors.cardBg,
            boxShadow: "none",
            padding: "18px",
            boxSizing: "border-box",
            ...style,
        }, children: children }));
}
